import React from 'react'
import '../css/Header.css'

export default function ConnectHeader() {
  return (
    <>
    
<header className='d-flex justify-content-end bg-set py-3   '>
<span className='connectButton'>Create</span>
<span className='connectButton'>Analog MainNet</span>
<span className='connectButton'> Connect</span>


</header>
    </>
  )
}
